import { AnalyticsAttributes } from '@missionlabs/analytics-react';
import useApp from 'hooks/redux/useApp';
import useAuth from 'hooks/redux/useAuth';
import useUser from 'hooks/redux/useUser';
import React, { ReactNode, useMemo } from 'react';

interface Props {
    children: ReactNode;
}

const Attributes = ({ children }: Props) => {
    const user = useUser();
    const app = useApp();
    const auth = useAuth();

    const attributesToSet = useMemo(
        () => ({
            environment: process.env.REACT_APP_ENV,
            roles: auth?.roles,
            companyName: app?.ID,
            username: user?.username,
        }),
        [process.env.REACT_APP_ENV, auth?.roles, app?.ID, user?.username]
    );

    return (
        <AnalyticsAttributes attributes={attributesToSet}>
            {children}
        </AnalyticsAttributes>
    );
};

export default Attributes;
